module.exports = __webpack_public_path__ + "img/logo-manitou.29a7ef71.svg";